import { IChangeDishPositionContext } from './changeDishPositionContext';

export enum ChangeDishPositionActionTypes {
	SET_ID_CUSTOMER = 'SET_ID_CUSTOMER',
	SET_ID_RESTAURANT = 'SET_ID_RESTAURANT',
	SET_ID_CATEGORY = 'SET_ID_CATEGORY',
	SET_ID_SUB_CATEGORY = 'SET_ID_SUB_CATEGORY',
	RESET_SELECTED_CONTROLS = 'RESET_SELECTED_CONTROLS',
	SET_POSITIONS_DATA = 'SET_POSITIONS_DATA',
	CHANGE_TYPE_OF_MODAL_WINDOW = 'CHANGE_TYPE_OF_MODAL_WINDOW',
	SET_VISIBLE_ADDITIONAL_RESTAURANTS_MODAL = 'SET_VISIBLE_ADDITIONAL_RESTAURANTS_MODAL',
	TOGGLE_APPLY_TO_ONE = 'TOGGLE_APPLY_TO_ONE',
	SET_ADDITIONAL_RESTAURANTS = 'SET_ADDITIONAL_RESTAURANTS',
	SET_FETCHED_RESTAURANTS = 'SET_FETCHED_RESTAURANTS',
}

interface ISetIDCustomer {
	type: ChangeDishPositionActionTypes.SET_ID_CUSTOMER;
	payload: {
		IDSelectedCustomer: IChangeDishPositionContext['IDSelectedCustomer'];
	};
}

interface ISetIDRestaurant {
	type: ChangeDishPositionActionTypes.SET_ID_RESTAURANT;
	payload: {
		IDSelectedRestaurant: IChangeDishPositionContext['IDSelectedRestaurant'];
	};
}

interface ISetIDCategory {
	type: ChangeDishPositionActionTypes.SET_ID_CATEGORY;
	payload: {
		IDSelectedCategory: IChangeDishPositionContext['IDSelectedCategory'];
	};
}

interface ISetIDSubCategory {
	type: ChangeDishPositionActionTypes.SET_ID_SUB_CATEGORY;
	payload: {
		IDSelectedSubCategory: IChangeDishPositionContext['IDSelectedSubCategory'];
	};
}

interface IResetSelectedControls {
	type: ChangeDishPositionActionTypes.RESET_SELECTED_CONTROLS;
}

interface ISetPositionsData {
	type: ChangeDishPositionActionTypes.SET_POSITIONS_DATA;
	payload: {
		positionsData: IChangeDishPositionContext['positionsData'];
	};
}

interface IChangeTypeOfModalWindow {
	type: ChangeDishPositionActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW;
	payload: {
		typeOfModalWindow: IChangeDishPositionContext['typeOfModalWindow'];
	};
}

interface ISetVisibleAdditionalRestaurantsModal {
	type: ChangeDishPositionActionTypes.SET_VISIBLE_ADDITIONAL_RESTAURANTS_MODAL;
	payload: {
		isVisibleAdditionalRestaurantsModal: IChangeDishPositionContext['isVisibleAdditionalRestaurantsModal'];
		isApplyToOne: IChangeDishPositionContext['isApplyToOne'];
		selectedAdditionalRestaurants: IChangeDishPositionContext['selectedAdditionalRestaurants'];
	};
}

interface IToggleApplyToOne {
	type: ChangeDishPositionActionTypes.TOGGLE_APPLY_TO_ONE;
}

interface ISetAdditionalRestaurants {
	type: ChangeDishPositionActionTypes.SET_ADDITIONAL_RESTAURANTS;
	payload: {
		selectedAdditionalRestaurants: IChangeDishPositionContext['selectedAdditionalRestaurants'];
	};
}

interface ISetFetchedRestaurants {
	type: ChangeDishPositionActionTypes.SET_FETCHED_RESTAURANTS;
	payload: {
		fetchedRestaurants: IChangeDishPositionContext['fetchedRestaurants'];
	};
}

export type TChangeDishPositionActions =
	| ISetIDCustomer
	| ISetIDRestaurant
	| ISetIDCategory
	| ISetIDSubCategory
	| IResetSelectedControls
	| ISetPositionsData
	| IChangeTypeOfModalWindow
	| ISetVisibleAdditionalRestaurantsModal
	| IToggleApplyToOne
	| ISetAdditionalRestaurants
	| ISetFetchedRestaurants;
